import { useAppSelector } from '../hooks';
import { RootState } from '../store';

export const Spinner = () => (
  <div className="relative flex items-center justify-center">
    {/* Spinning background ring */}
    <div className="absolute w-16 h-16 border-4 border-brand-500/20 border-t-brand-500 rounded-full animate-spin" />
  </div>
);

export const FullPageLoader = () => (
  <div className="fixed inset-0 bg-white/60 dark:bg-neutral-950/60 backdrop-blur-md flex items-center justify-center z-[9999]">
    <Spinner />
  </div>
);

const LoadingOverlay = () => {
  const loadingCount = useAppSelector(
    (state: RootState) => state.loading.loadingCount
  );

  if (loadingCount === 0) {
    return null;
  }

  return <FullPageLoader />;
};

export default LoadingOverlay;
